type Props = { index: number; html: string };

function sanitize(html: string): string {
  const escaped = html
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
  return escaped
    .replace(/&lt;strong&gt;/g, '<strong class="verdict-strong">')
    .replace(/&lt;\/strong&gt;/g, "</strong>")
    .replace(/&lt;em&gt;/g, '<em class="verdict-em">')
    .replace(/&lt;\/em&gt;/g, "</em>");
}

export function VerdictCondition({ index, html }: Props) {
  return (
    <div
      data-testid={`verdict-condition-${index}`}
      style={{
        display: "grid",
        gridTemplateColumns: "36px 1fr",
        gap: 22,
        marginBottom: 28,
      }}
    >
      <div style={{ position: "relative", marginTop: 6 }}>
        <span
          aria-hidden
          style={{
            display: "block",
            width: 22,
            height: 22,
            borderRadius: "50%",
            background: "var(--qv3-ink)",
            border: "1px solid var(--qv3-gold)",
          }}
        />
      </div>
      <div
        style={{
          fontFamily: "var(--qv3-font-serif)",
          fontStyle: "normal",
          fontWeight: 400,
          fontSize: 20,
          color: "var(--qv3-ink)",
          lineHeight: 1.5,
          letterSpacing: "-0.01em",
        }}
      >
        <span
          style={{
            fontFamily: "var(--qv3-font-mono)",
            fontWeight: 500,
            fontSize: 14,
            color: "var(--qv3-gold)",
            marginRight: 12,
            letterSpacing: 1,
          }}
        >
          {String(index).padStart(2, "0")}
        </span>
        <span
          dangerouslySetInnerHTML={{ __html: sanitize(html) }}
        />
        <style>{`
          .verdict-strong{font-style:normal;font-weight:500;color:var(--qv3-gold);}
          .verdict-em{font-style:italic;}
        `}</style>
      </div>
    </div>
  );
}

export default VerdictCondition;
